import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
export function BabyFormatSection() {
  return <section className="py-12 sm:py-16 md:py-20 bg-gradient-to-br from-baby-cream via-white to-baby-pink-light" data-id="element-75">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-76">
        <div className="text-center mb-8 sm:mb-12 animate-fade-in-up" data-id="element-77">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-78">
            Empieza Hoy Mismo
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-79">
            Acceso instantáneo en todos tus dispositivos
          </p>
        </div>

        {/* Hero Multi-Device Image */}
        <div className="mb-8 sm:mb-12 animate-fade-in-up" style={{
        animationDelay: '0.2s'
      }} data-id="element-80">
          <div className="relative rounded-baby-lg overflow-hidden shadow-baby-glow" data-id="element-81">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4ymZxPD3vTPXYcS6PQzKst/10-multi-device_warm_mockup_image.png" alt="30 Recetas para Bebés disponible en celular y tablet - Descarga inmediata en PDF" className="w-full h-auto" data-id="element-82" />
          </div>
        </div>

        {/* Key Features */}
        <div className="grid sm:grid-cols-3 gap-6 sm:gap-8 stagger-children" data-id="element-83">
          <div className="bg-white/90 backdrop-blur-baby p-6 sm:p-8 rounded-baby-lg border-2 border-baby-blue-light shadow-baby-soft text-center" data-id="element-84">
            <div className="w-14 h-14 bg-baby-gradient-blue rounded-full flex items-center justify-center mx-auto mb-4 shadow-baby-soft" data-id="element-85">
              <span className="text-2xl" data-id="element-86">📱</span>
            </div>
            <h3 className="font-bold text-base sm:text-lg text-gray-900 mb-2" data-id="element-87">
              En tu celular
            </h3>
            <p className="text-sm sm:text-base text-gray-700" data-id="element-88">
              Consulta mientras cocinas, sin necesidad de internet
            </p>
          </div>

          <div className="bg-white/90 backdrop-blur-baby p-6 sm:p-8 rounded-baby-lg border-2 border-baby-pink-light shadow-baby-soft text-center" data-id="element-89">
            <div className="w-14 h-14 bg-baby-gradient-pink rounded-full flex items-center justify-center mx-auto mb-4 shadow-baby-pink" data-id="element-90">
              <span className="text-2xl" data-id="element-91">💻</span>
            </div>
            <h3 className="font-bold text-base sm:text-lg text-gray-900 mb-2" data-id="element-92">
              En tu tablet o computadora
            </h3>
            <p className="text-sm sm:text-base text-gray-700" data-id="element-93">
              Pantalla grande para ver mejor los pasos
            </p>
          </div>

          <div className="bg-white/90 backdrop-blur-baby p-6 sm:p-8 rounded-baby-lg border-2 border-baby-blue-light shadow-baby-soft text-center" data-id="element-94">
            <div className="w-14 h-14 bg-baby-gradient-blue rounded-full flex items-center justify-center mx-auto mb-4 shadow-baby-soft" data-id="element-95">
              <span className="text-2xl" data-id="element-96">🖨️</span>
            </div>
            <h3 className="font-bold text-base sm:text-lg text-gray-900 mb-2" data-id="element-97">
              Imprime tus favoritas
            </h3>
            <p className="text-sm sm:text-base text-gray-700" data-id="element-98">
              Pega en la nevera las recetas que más uses
            </p>
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="mt-8 sm:mt-12 text-center animate-fade-in-up" style={{
        animationDelay: '0.4s'
      }} data-id="element-99">
          <div className="inline-block bg-gradient-to-br from-baby-blue-light to-baby-pink-light p-6 sm:p-8 rounded-baby-lg border-2 border-baby-lavender shadow-baby-glow" data-id="element-100">
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 mb-4" data-id="element-101">
              <div className="flex items-center gap-2" data-id="element-102">
                <CheckCircleIcon className="w-5 h-5 text-baby-blue" data-id="element-103" />
                <span className="text-sm sm:text-base font-semibold text-gray-800" data-id="element-104">
                  Descarga Inmediata
                </span>
              </div>
              <div className="flex items-center gap-2" data-id="element-105">
                <CheckCircleIcon className="w-5 h-5 text-baby-pink" data-id="element-106" />
                <span className="text-sm sm:text-base font-semibold text-gray-800" data-id="element-107">
                  Formato PDF
                </span>
              </div>
              <div className="flex items-center gap-2" data-id="element-108">
                <CheckCircleIcon className="w-5 h-5 text-baby-blue" data-id="element-109" />
                <span className="text-sm sm:text-base font-semibold text-gray-800" data-id="element-110">
                  Sin Suscripción
                </span>
              </div>
            </div>
            <p className="text-lg sm:text-xl font-bold text-gray-900" data-id="element-111">
              Compra una vez, úsalo para siempre
            </p>
          </div>
        </div>
      </div>
    </section>;
}